<template>
	<div>
		<div class="d-flex flex-wrap justify-space-between">
			<h2 class="mb-4">Business Name</h2>
		</div>

		<div>
			<v-card>
				<v-data-table :headers="headers" :items="businessNameList.data" :footer-props="{ itemsPerPageOptions: [-1] }" :hide-default-footer="true">
					<template v-slot:top>
						<v-row class="mx-0 flex-row-reverse">
							<v-col cols="12" sm="2">
								<v-dialog v-model="dialogEditedItem" persistent max-width="700px">
									<template v-slot:activator="{ on, attrs }">
										<v-btn color="primary" dark block v-bind="attrs" v-on="on" @click="addItem()">Add</v-btn>
									</template>
									<v-card>
										<v-card-title>
											<span class="headline">
												{{ isNewBusinessName ? "Add" : "Edit" }}
												Business Name
											</span>
											<v-spacer></v-spacer>
											<v-btn icon @click="close">
												<v-icon>mdi-close</v-icon>
											</v-btn>
										</v-card-title>

										<v-form ref="formEditedItem" v-model="validEditedItem" @submit.prevent="save">
											<v-card-text>
												<v-container>
													<v-row>
														<v-col cols="12">
															<v-text-field v-model="editedItem.name" label="Business Name" :rules="[rules.required]"></v-text-field>
														</v-col>
													</v-row>
												</v-container>
											</v-card-text>

											<v-card-actions>
												<v-spacer></v-spacer>
												<v-btn color="default" @click="close">Cancel</v-btn>
												<v-btn color="primary" :disabled="!validEditedItem" type="submit">Save</v-btn>
											</v-card-actions>
										</v-form>
									</v-card>
								</v-dialog>
								<v-dialog v-model="dialogDelete" max-width="400px">
									<v-card>
										<v-card-title class="headline warning justify-center pa-12" primary-title>
											<v-icon color="white" size="120">mdi-alert-circle-outline</v-icon>
										</v-card-title>

										<v-card-text class="pa-6" style="text-align: center">
											<span class="title">Warning</span>
											<br />
											<br />
											<p style="text-align: justify">Once you confirm, business name will be permanently deleted.</p>
										</v-card-text>
										<v-card-actions>
											<v-spacer></v-spacer>
											<v-btn color="default" @click="closeDelete">Cancel</v-btn>
											<v-btn color="error" @click="deleteItemConfirm">Confirm</v-btn>
											<v-spacer></v-spacer>
										</v-card-actions>
									</v-card>
								</v-dialog>
							</v-col>
							<v-col cols="12" sm="10">
								<v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details @keyup="listBusinessName()"></v-text-field>
							</v-col>
						</v-row>
					</template>
					<template v-slot:item.action="{ item }">
						<v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
						<v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
					</template>
				</v-data-table>

				<div class="d-flex flex-wrap justify-space-between pt-5 pb-5">
					<div></div>
					<div class="d-inline-flex">
						<span style="margin-top: 10px; font-size: 12px;"> Rows per page : </span>
						<v-select
							v-model="businessNameList.size"
							:items="rowsPerPage"
							style="margin: -9px 0px 0px 10px; width: 60px; font-size: 12px;"
							@change="listBusinessName()"
							hide-details=""
						></v-select>
						<span style="margin-top: 10px; margin-left: 20px; font-size: 12px;"> {{getPageLenght()}}</span>

						<v-pagination
							class="pl-6"
							v-model="businessNameList.page"
							:length="businessNameList.length"
							:total-visible="0"
							@input="listBusinessName()"
							elevation="0"
						></v-pagination>
					</div>
				</div>
			</v-card>
		</div>

	</div>
</template>

<script>

import axios from "axios";

export default {
	data() {
		return {
			dialogEditedItem: false,
			dialogDelete: false,
			validEditedItem: true,
			isNewBusinessName: true,
			businessNameList: { data: [], page: 1, size: 5, length: 0, total: 0 },
			search: "",
			headers: [
				{ text: "Business Name", value: "name", width: "90%" },
				{ text: "Action", value: "action", sortable: false, width: "10%" }
			],
			editedItem: { transitMap: {}, active: false },
			defaultItem: { transitMap: {}, active: false },
			rules: {
				required: (v) => !!v || "Required."
			},
			baseLocation: axios.defaults.baseURL,
			rowsPerPage: [5, 10, 'All'],
		};
	},
	computed: {
		experienceId() {
			return this.$route.params.experienceId;
		},
	},
	mounted() {
		this.listBusinessName();
	},
	methods: {
		listBusinessName() {
			if (this.businessNameList.size === 'All') {
				this.businessNameList.page = 1;
				this.businessNameList.size = this.businessNameList.total;
			}
			axios
				.post("/system/businessname/list", {	
					experienceId: this.experienceId, 
					keyword: this.search,
					page: this.businessNameList.page,
					size: this.businessNameList.size
				})
				.then((response) => {
					this.businessNameList = response.data;
				})
				.catch(() => {});
		},
		addItem() {
			this.isNewBusinessName = true;
			this.$refs.formEditedItem.resetValidation();
		},
		editItem(item) {
			this.isNewBusinessName = false;
			this.editedItem = Object.assign({}, item);
			axios
				.post("/system/businessname", { id: item.id })
				.then(() => {
					this.dialogEditedItem = true;
				})
				.catch(() => {});
		},
		deleteItem(item) {
			this.editedItem = Object.assign({}, item);
			this.dialogDelete = true;
		},
		deleteItemConfirm() {
			axios
				.post("/system/businessname/delete", { id: this.editedItem.id })
				.then(() => {
					this.listBusinessName();
					this.closeDelete();
				})
				.catch(() => {});
		},
		close() {
			this.$refs.formEditedItem.resetValidation();
			this.dialogEditedItem = false;

			this.$nextTick(() => {
				this.editedItem = Object.assign({}, this.defaultItem);
			});
		},
		closeDelete() {
			this.dialogDelete = false;
			this.$nextTick(() => {
				this.editedItem = Object.assign({}, this.defaultItem);
			});
		},
		save() {
			let formData = new FormData();

			this.editedItem.experienceId = this.experienceId;
			formData.append("entity", JSON.stringify(this.editedItem));

			var url = "/system/businessname/add";
			if (!this.isNewBusinessName) {
				url = "/system/businessname/edit";
			}
			axios
				.post(url, formData)
				.then(() => {
					this.listBusinessName();
					this.close();
				})
				.catch(() => {});
		},
		getPageLenght(){
			let start = ((this.businessNameList.page -1) * this.businessNameList.size) + 1;
			let end = start + this.businessNameList.size - 1;

			if (this.businessNameList.total < end) {
				end = this.businessNameList.total;
			}
			return start + "-" + end + " of " + this.businessNameList.total; 
		}
	}
};
</script>